import type { IconType } from 'react-icons';

export interface StatCardProps {
    label: string;
    value: string;
    hint?: string;
    Icon?: IconType;
    accent?: boolean;
    loading?: boolean;
}

/** Headline metric card used across both dashboards (FR-23 / FR-32). */
export default function StatCard({ label, value, hint, Icon, accent = false, loading = false }: StatCardProps) {
    return (
        <div
            className={`rounded-xl border p-5 transition-colors ${
                accent ? 'border-primary/30 bg-primary/5' : 'border-[#E0E0E0] bg-white'
            }`}
        >
            <div className="flex items-start justify-between gap-3">
                <p className="text-[13px] leading-5 text-[#6b6b6b]">{label}</p>
                {Icon && (
                    <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                            accent ? 'bg-primary/15 text-primary' : 'bg-[#f5f5f5] text-[#6b6b6b]'
                        }`}
                    >
                        <Icon size={16} />
                    </span>
                )}
            </div>

            {loading ? (
                <div className="skeleton-shimmer mt-3 h-8 w-24 rounded-md" />
            ) : (
                <p className="mt-2 text-[28px] font-bold leading-none text-secondary">{value}</p>
            )}

            {hint && <p className="mt-2 text-[12px] leading-4 text-[#9a9a9a]">{hint}</p>}
        </div>
    );
}
